export const HEADER_IDS = {
    DATE: 'date',
    AGENCY: 'agencyDisplay',
    SHORT_TERM: 'shortTerm',
    LONG_TERM: 'longTerm',
    OUTLOOK: 'outlook',
    DETAILS: 'details',
} as const;

export const SHORT_TERM_RATING_LABEL = 'Short Term Rating';

export const LONG_TERM_RATING_LABEL = 'Long Term Rating';

export const OUTLOOK_LABEL = 'Outlook';

export const headers = [
    { id: HEADER_IDS.DATE, label: 'Date' },
    { id: HEADER_IDS.AGENCY, label: 'Agency' },
    { id: HEADER_IDS.SHORT_TERM, label: SHORT_TERM_RATING_LABEL },
    { id: HEADER_IDS.LONG_TERM, label: LONG_TERM_RATING_LABEL },
    { id: HEADER_IDS.OUTLOOK, label: OUTLOOK_LABEL },
    { id: HEADER_IDS.DETAILS, label: 'Details' },
];

export const PDF_HEADERS = headers.filter((header) => header.id !== HEADER_IDS.DETAILS);

export const VIEW_LABEL = 'View';

export const VIEW_DETAILS_LABEL = 'View Details';

export const UNRATED_MESSAGE = 'No credit ratings available';

export const EMPTY_CELL = '-';

export const DRAWER_TITLE_SUFFIX = 'RATING';

export const DRAWER_COLUMNS = {
    INSTRUMENT: 'Instrument',
    AMOUNT: 'Amount (₹)',
    RATING: 'Rating',
    ACTION: 'Action',
    OUTLOOK: OUTLOOK_LABEL,
    REMARKS: 'Remarks',
} as const;

export const UPDATED_ON_LABEL = 'Updated on';

export const CREDIT_RATING_DRAWER_WIDTH = '47rem';

export const BASE_AMOUNT_CURRENCY = 'INR';

export enum CreditOutlook {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    NEUTRAL = 'neutral',
}

export const NOT_AVAILABLE_LABEL = 'Not available';

/** Drawer table columns in display order; `widthClass` names the column's width class in the date panel stylesheet. */
export const DRAWER_TABLE_COLUMNS: ReadonlyArray<{ label: string; widthClass?: string; alignRight?: boolean }> = [
    { label: DRAWER_COLUMNS.INSTRUMENT },
    { label: DRAWER_COLUMNS.AMOUNT, widthClass: 'AmountColumn', alignRight: true },
    { label: DRAWER_COLUMNS.RATING, widthClass: 'RatingColumn' },
    { label: DRAWER_COLUMNS.ACTION, widthClass: 'ActionColumn' },
    { label: DRAWER_COLUMNS.OUTLOOK, widthClass: 'TextColumn' },
    { label: DRAWER_COLUMNS.REMARKS, widthClass: 'TextColumn' },
];

export const MCA_FILING_LOCKED_MESSAGE = 'Unlock MCA Filings to see Credit Rating';
